module.exports = __webpack_public_path__ + "img/CodyWalker.a2117221.jpg";